import {PureComponent} from 'react'
import PropTypes from 'prop-types'
import {Link} from 'react-router-dom'
import Edit from 'react-feather/dist/icons/edit.js'
import Mail from 'react-feather/dist/icons/mail.js'
import Trash from 'react-feather/dist/icons/trash.js'

import Date from '../../../../shared/components/Moment/Date.jsx'

import {generate} from '../../../routes.js'
import conf from '../../../conf.js'

import './OfferAnswerList.scss'

export default class OfferAnswersList extends PureComponent {
  static propTypes = {
    list: PropTypes.array,
    isAdmin: PropTypes.bool
  }

  static defaultProps = {
    className: '',
    list: [],
    isAdmin: false
  }

  edit = (item, offset) => {
    if (this.props.edit) {
      this.props.edit(item, offset)
    }
  }

  deny = (item, offset) => {
    if (this.props.edit) {
      this.props.deny(item, offset)
    }
  }

  remove = (item, offset) => {
    if (this.props.remove) {
      this.props.remove(item, offset)
    }
  }

  render() {
    return (
      <div className="offer-answers-list">
        {
          this.props.list.map((item, offset) => {
            return (
              <div
                className="row d-flex align-items-center offer-answers-item"
                key={offset}
              >
                <div className="col-xxl-10 col-md-8 actions-answer">
                  <div className="title">
                    Disponibilité au <Date date={item.availability_date}/> (TJM : {item.tjm} &euro;)<br/>
                    Créé le <Date date={item.created_at}/>&nbsp;
                    par <Link to={generate(
                      {
                        name: 'old-freelance-profile',
                        parameters: {
                          slug: 'freelance',
                          user_id: item.user.id,
                          freelance_id: item.user.freelance_id
                        }
                      }
                    )}>{item.user.fullname}</Link>
                  </div>
                  <div className="comment">
                    <p dangerouslySetInnerHTML={{__html: item.comment}}/>
                  </div>
                </div>
                <div className="col-xxl-2 col-md-4">
                  <div className="row justify-content-center">
                    <button
                      onClick={() => this.edit(item, offset)}
                      type="button"
                      className="btn btn-round btn-sm btn-round btn-outline-primary m-2"
                    >
                      <Edit size={20}/>
                    </button>
                    {this.props.isAdmin &&
                    <button
                      onClick={() => this.deny(item, offset)}
                      type="button"
                      className="btn btn-round btn-sm btn-round btn-outline-secondary m-2"
                      disabled={!isNaN(item.denial_motive)}
                    >
                      <Mail size={20}/>
                    </button>
                    }
                    <button
                      onClick={() => this.remove(item, offset)}
                      type="button"
                      className="btn btn-round btn-sm btn-outline-danger m-2"
                    >
                      <Trash size={20}/>
                    </button>
                  </div>
                  {!isNaN(item.denial_motive) &&
                  <div className="row justify-content-center">
                    <span className="badge badge-danger">
                      Candidature refusée :<br/>{conf.offerAnswerDenials[item.denial_motive]}
                    </span>
                  </div>
                  }
                </div>
              </div>
            )
          })
        }
      </div>
    )
  }
}